import discardSkypeOption from './data/mutators/discardSkypeOptions';
import saveSkypeOption from './orchestration/saveSkypeOptions';
import isSkypeEnabled from './utils/isSkypeEnabled';
import isSkypeOptionDirty from './utils/isSkypeOptionDirty';
import SkypeNotificationFull from './view/SkypeNotificationFull';
import { Option } from 'owa-options-core';
import * as React from 'react';

let SkypeNotificationOption: Option = {
    key: 'skypeNotifications',
    titleStringKey: 'optionSubcategory_chatandcall',
    searchTermsStringKey: 'optionSubcategory_notifications',
    fullOptionFormSettings: {
        render: () => <SkypeNotificationFull />,
        isDirty: isSkypeOptionDirty,
        onSave: saveSkypeOption,
        onDiscard: discardSkypeOption,
    },
    isHidden: () => !isSkypeEnabled(),
};

export default SkypeNotificationOption;
